import React from 'react'
import PropTypes from 'prop-types'

/**
 * @typedef {Object} PageTitleProps
 * @property {string} title - The title text to display
 * @property {string} [loadingText='loading...'] - Text to show when title is not available
 * @property {string} [fontSize='24px'] - Font size for the title
 */

/**
 * PageTitle component for displaying page titles with consistent styling
 * @param {PageTitleProps} props - Component props
 * @returns {JSX.Element} Rendered h1 element with title
 */
const PageTitle = ({ title, loadingText = 'loading...', fontSize = '24px' }) => {
  return (
    <h1 style={{ fontSize }}>
      {title ? title : loadingText}
    </h1>
  )
}

PageTitle.propTypes = {
  title: PropTypes.string,
  loadingText: PropTypes.string,
  fontSize: PropTypes.string
}

export default PageTitle 